import { useEffect, useState } from 'react';
import { useLocalTranslation } from '@/hooks/useLocalTranslation';
import { Modal } from 'react-bootstrap';
import LightGrayCross from "@/assets/icons/lightGrayCross.png";
import "@/components/common/emptyModal/style.css"
import { themes } from '@/constants/colors_v2';
import { useSelector } from 'react-redux';
import { RootState } from '@/store';
import { addCurrentThemeClassToEle } from '@/utils';

function ConfirmCertificateDeliveredModal(props: any) {
    const { timeline, common } = useLocalTranslation();
    const [remainingSeconds, setRemainingSeconds] = useState(10);
    const [isButtonEnabled, setIsButtonEnabled] = useState(false);
    const currentTheme = useSelector((state: RootState) => state.currentThemeReducer.currentTheme);

    useEffect(() => {
        let interval: NodeJS.Timeout;

        if (props.show) {
            setRemainingSeconds(10);
            setIsButtonEnabled(false);

            interval = setInterval(() => {
                setRemainingSeconds((prev) => {
                    if (prev <= 1) {
                        clearInterval(interval);
                        setIsButtonEnabled(true);
                        return 0;
                    }
                    return prev - 1;
                });
            }, 1000);
        }

        return () => clearInterval(interval);
    }, [props.show]);

    return (
        <Modal
            show={props.show}
            onHide={() => props.handleClose('close')} centered>
            <div className={`p-[20px] ${addCurrentThemeClassToEle(currentTheme, 'emptyModalIndex')}`}>

                <Modal.Header className='p-0 border-0 mb-[10px]'>


                    {currentTheme === themes.dark ? (
                        <div className='darkThemetopCloseButtonHelperModelCon'>
                            <Modal.Title className='text-[16px] font-semibold watchModel12Title'>
                                {/* {props.popupInfo.title} */}
                            </Modal.Title>

                            <button
                                onClick={() => props.handleClose('close')}
                                type="button"
                                className='text-[14px]'
                                aria-label="Close">
                                <img src={LightGrayCross} alt='LightGrayCross' className='w-[14px]' />
                            </button>
                        </div>
                    ) : (
                        <>
                            <Modal.Title className='text-[16px] font-semibold watchModel12Title'>
                                {/* {props.popupInfo.title} */}
                            </Modal.Title>

                            <button
                                onClick={() => props.handleClose('close')}
                                type="button"
                                className='btn-close topCloseButtonHelper'
                                aria-label="Close">
                            </button>

                        </>
                    )}
                    {/* <button
                        onClick={() => props.handleClose('close')}
                        type="button"
                        className="btn-close text-[14px]" aria-label="Close"></button> */}


                </Modal.Header>

                <Modal.Body className='p-0'>
                    <p className='mb-[10px]'>{timeline.certificateSection.certificateDispatched.modal.p1}</p>
                    <div className='flex gap-[10px]'>
                        <button
                            onClick={() => props.handleClose('confirmCertificateDelivered')}
                            disabled={!isButtonEnabled}
                            style={{
                                cursor: isButtonEnabled ? 'pointer' : 'not-allowed',
                                opacity: isButtonEnabled ? '1' : '0.7'
                            }}
                            className={`watchModel12LeftBtn w-1/2 cursor-pointer py-[7px] rounded-[5px] text-[14px]`}>
                            {common.statusText.confirmBtn} {!isButtonEnabled && ` (${remainingSeconds})s`}
                        </button>

                        <button
                            onClick={() => props.handleClose('close')}
                            className='w-1/2 cursor-pointer bg-[#1573FE] py-[7px] text-white rounded-[5px] text-[14px]'>
                            {common.statusText.cancleBtn}
                        </button>
                    </div>

                </Modal.Body>

            </div>
        </Modal>
    );
}

export default ConfirmCertificateDeliveredModal;